var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner',{attrs:{"company-name":'禾祺科技',"title":'档案管理新闻与咨询',"description":'由纸质档案向电子化档案转型的必选工具。',"background-url":require('@/assets/images/nav/zx2.jpeg')}}),_c('oldInfoList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }